import {
  FETCH_MERCHANTS_REQUEST,
  FETCH_MERCHANTS_SUCCESS,
  FETCH_MERCHANTS_FAILURE,
  UPDATE_MERCHANT_STATUS_REQUEST,
  UPDATE_MERCHANT_STATUS_SUCCESS,
  UPDATE_MERCHANT_STATUS_FAILURE,
} from "../actions/types";

const initialState = {
  merchants: [],
  loading: false,
  error: null,
  message: "",
  pagination: {
    total: 0,
    page: 1,
    size: 10,
    pages: 1,
  },
};

export default function merchantReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MERCHANTS_REQUEST:
    case UPDATE_MERCHANT_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_MERCHANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        merchants: action.payload.data || [],  
        pagination: {
          total: action.payload.total || 0,
          page: action.payload.page || 1,
          size: action.payload.size || 10,
          pages: action.payload.pages || 1,
        },
        message: "Merchants loaded successfully",
      };
    case FETCH_MERCHANTS_FAILURE:
    case UPDATE_MERCHANT_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_MERCHANT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        merchants: state.merchants.map((m) =>
          m.merchant_id === action.payload.data?.merchant_id
            ? { ...m, ...action.payload.data }
            : m
        ),
        message: "Merchant status updated successfully",
      };

    default:
      return state;
  }
}